export const getIsAlgoEditConfigFetching = (state) =>
  state.algoEditConfig.isFetching;

export const getIsAlgoEditConfigErrorMessage = (state) =>
  state.algoEditConfig.errorMessage;

export const getAlgoEditConfig = (state) =>
  state.algoEditConfig.data.data ? state.algoEditConfig.data.data : {};

export const getAlgoEditConfigConfigurations = (state) =>
  state.algoEditConfig.data.data &&
  state.algoEditConfig.data.data.configurations
    ? state.algoEditConfig.data.data.configurations
    : {};

export const getAlgoEditConfigLegs = (state) =>
  state.algoEditConfig.data.data &&
  state.algoEditConfig.data.data.configurations &&
  state.algoEditConfig.data.data.configurations.legs
    ? state.algoEditConfig.data.data.configurations.legs
    : [];

export const getAlgoEditConfigLegUpdatedAt = (state) =>
  state.algoEditConfig.configLegUpdatedAt;

export const getAlgoId = (state) =>
  state.algoEditConfig.data.data && state.algoEditConfig.data.data._id
    ? state.algoEditConfig.data.data._id
    : '';

export const getAlgoMainStatus = (state) =>
  state.algoEditConfig.data &&
  state.algoEditConfig.data.data &&
  state.algoEditConfig.data.data.status
    ? state.algoEditConfig.data.data.status
    : '';

export const getAlgoHealth = (state) => state.algoEditConfig.health;

export const getSettingsClientIdShow = (state) =>
  state.algoEditConfig.settings.clientIdShow;

export const getSettingsModifyWhileLive = (state) =>
  state.algoEditConfig.settings.modifyWhileLive;

export const getTerminateStart = (state) =>
  state.algoEditConfig.settings.terminateStart;

export const getSqOffStart = (state) =>
  state.algoEditConfig.settings.sqOffStart;

export const getModifyLiveSaveStart = (state) =>
  state.algoEditConfig.settings.saveStart;

export const getCreateLegData = (state) => state.algoEditConfig.createLeg;

export const getIsLoading = (state) => state.algoEditConfig.settings.loading;

export const getCreateLegErrors = (state) =>
  state.algoEditConfig.createLegErrors;

export const getValidationErrors = (state) => state.algoEditConfig.errors;

export const getCreateAlgoErrors = (state) =>
  state.algoEditConfig.createAlgoErrors;

export const getPositionTableModalsData = (state) =>
  state.algoEditConfig.positionTableModals;

export const getPositionTableJourneyModalsData = (state) =>
  state.algoEditConfig.positionTableJourneyModals;

export const getIsPageLoaded = (state) => state.algoEditConfig.pageLoaded;

export const getProfitLockAndSlTrailing = (state) =>
  state.algoEditConfig.profitLockAndSlTrailing;

export const getConfigSave = (state) =>
  state.algoEditConfig.settings.configSave;

export const getOpenCreateModal = (state) =>
  state.algoEditConfig.settings.openCreateModal;

export const getConfirmationsPositionalMIS = (state) =>
  state.algoEditConfig.confirmations.positionalMIS;

export const getIsLegDuplicateLoading = (state) =>
  state.algoEditConfig.legDuplicateLoading
    ? state.algoEditConfig.legDuplicateLoading
    : false;
